import { site } from '@/data/site';

export default function MobileCallBar() {
  return (
    <div className="lg:hidden fixed inset-x-0 bottom-0 z-50 border-t border-primary-900/20 bg-background-50/95 backdrop-blur-md p-3">
      <div className="flex items-center gap-3">
        <a
          href={site.phoneHref}
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 font-label font-semibold text-base py-3.5 whitespace-nowrap cursor-pointer animate-pulse-ring"
        >
          <i className="ri-phone-fill text-lg" />
          Jetzt anrufen
        </a>
        <a
          href="#kontakt"
          aria-label="Zum Kontaktformular"
          className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950 text-xl cursor-pointer"
        >
          <i className="ri-mail-send-line" />
        </a>
      </div>
    </div>
  );
}